import {
  PayPalScriptProvider,
  PayPalButtons,
  usePayPalScriptReducer,
} from '@paypal/react-paypal-js'
import { Button } from '@material-ui/core'
import { firebaseDb } from '../../config/firebaseConfig'
import { emailInstance } from '../../config/mailingConfig'
import {
  createReservation,
  assignResource,
  checkResourceUsage,
  updateReservationStatus,
} from '../../services/FirebaseServices/reservationServices'

import {
  getExperienceById,
} from '../../services/FirebaseServices/experienceServices'

import { statePayments, stateReservation } from '../../utils/enums'
import { formatDateToDB } from '../../utils/helpers'

import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'

//REDUX
import {
  makeSelectStartDate,
  makeSelectEndDate,
  makeSelectGuestAmount,
  makeSelectSingleDate,
  makeSelectTime,
  makeSelectChildAmount,
  makeSelectTotalPrice,
  makeSelectHotelHour,
  makeSelectPartialPrice,
  makeSelectService,
  makeSelectSelectedAddons,
  makeSelectAddonsPersonsPrice,
  makeSelectCode,
  makeSelectGiftCard,
} from '../../redux/ducks/reservationDetails'

import {
  makeSelectName,
  makeSelectLastName,
  makeSelectPhone,
  makeSelectEmail,
  makeSelectGiftedName,
  makeSelectGiftedLastName,
  makeSelectGiftedPhone,
  makeSelectGiftedEmail,
} from '../../redux/ducks/reservationInfo'

import {
  makeSelectTermsAndConditions,
} from '../../redux/ducks/verifyReservation'

import {
  makeSelectSingleExperience,
  makeSelectAgency,
} from '../../redux/ducks/experiences'

import {
  makeSelectTotalOrderPrice,
  makeSelectOrderProducts,
  makeSelectDeliveryAddress,
  makeSelectOrderIndications,
  makeSelectDispatchMethod,
} from '../../redux/ducks/restaurantMenu'
import {
  convertAMPMto24Hs,
  convertDateFormat,
  createNewReservationXML,
  parseXmlToJson,
  simplifyReservation,
} from '../../utils/HelpersChannel'
import axios from 'axios'

const stateSelector = createSelector(
  [
    makeSelectStartDate,
    makeSelectEndDate,
    makeSelectGuestAmount,
    makeSelectName,
    makeSelectLastName,
    makeSelectPhone,
    makeSelectEmail,
    makeSelectTermsAndConditions,
    makeSelectSingleExperience,
    makeSelectSingleDate,
    makeSelectTime,
    makeSelectChildAmount,
    makeSelectTotalPrice,
    makeSelectHotelHour,
    makeSelectAgency,
    makeSelectPartialPrice,
    makeSelectTotalOrderPrice,
    makeSelectOrderProducts,
    makeSelectDeliveryAddress,
    makeSelectOrderIndications,
    makeSelectDispatchMethod,
    makeSelectService,
    makeSelectSelectedAddons,
    makeSelectAddonsPersonsPrice,
    makeSelectCode,
    makeSelectGiftedName,
    makeSelectGiftedLastName,
    makeSelectGiftedPhone,
    makeSelectGiftedEmail,
    makeSelectGiftCard,
  ],
  (
    startDate,
    endDate,
    guestAmount,
    name,
    lastName,
    phone,
    email,
    termsAndConditions,
    singleExperience,
    singleDate,
    time,
    childAmount,
    totalPrice,
    hotelHour,
    agency,
    partialPrice,
    totalOrderPrice,
    orderProducts,
    deliveryAddress,
    orderIndications,
    dispatchMethod,
    service,
    selectedAddons,
    addonsPersonsPrice,
    code,
    giftedName,
    giftedLastName,
    giftedPhone,
    giftedEmail,
    giftCard,
  ) => ({
    startDate,
    endDate,
    guestAmount,
    name,
    lastName,
    phone,
    email,
    termsAndConditions,
    singleExperience,
    singleDate,
    time,
    childAmount,
    totalPrice,
    hotelHour,
    agency,
    partialPrice,
    totalOrderPrice,
    orderProducts,
    deliveryAddress,
    orderIndications,
    dispatchMethod,
    service,
    selectedAddons,
    addonsPersonsPrice,
    code,
    giftedName,
    giftedLastName,
    giftedPhone,
    giftedEmail,
    giftCard,
  }),
)

function PayPalModule({
  currencyExchanged,
  experienceResponse,
  agencyId,
  experienceId,
  isDiscountApplied,
  detailDiscount,
  isError,
  isExpirationCode,
  isErrorDay,
  validateTerms,
  clpToUsd,
  paypalClient,
  hotDeal,
  formatDateDif,
}) {
  const style = { tagline: 'false', minHeight: '62px', maxHeight: '62px' }
  const {
    startDate,
    endDate,
    guestAmount,
    name,
    lastName,
    phone,
    email,
    termsAndConditions,
    singleExperience,
    singleDate,
    time,
    childAmount,
    totalPrice,
    hotelHour,
    agency,
    partialPrice,
    totalOrderPrice,
    orderProducts,
    deliveryAddress,
    orderIndications,
    dispatchMethod,
    selectedAddons,
    addonsPersonsPrice,
    code,
    giftedName,
    giftedLastName,
    giftedPhone,
    giftedEmail,
    giftCard,
  } = useSelector(stateSelector)
  function PayPalButton() {
    return (
      <Button
        style={{
          width: '100%',
          // maxHeight: '70px',
          // minHeight: '70px',
          display: 'absolute',
          overflow: 'hidden',
          alignItems: 'baseline',
          justifyContent: 'center',
          paddingLeft: '0px !important',
        }}
      >
        <PayPalScriptProvider
          options={{
            'client-id': paypalClient,
            components: 'buttons',
            currency: 'USD',
          }}
        >
          <ButtonWrapper showSpinner={true} />
        </PayPalScriptProvider>
      </Button>
    )
  }

  const ButtonWrapper = ({ currency, showSpinner }) => {
    // usePayPalScriptReducer can be use only inside children of PayPalScriptProviders
    // This is the main reason to wrap the PayPalButtons in a new component
    const [{ options, isPending }, dispatch] = usePayPalScriptReducer()

    let reservationID = ''

    let reservationDetail = {}
    let totalDiscounted = currencyExchanged

    let link = `/reservation/detail/${agencyId}/${experienceId}/`

    const { partialPercentage, isPartialCharge } = experienceResponse

    if (isDiscountApplied) {
      totalDiscounted =
        currencyExchanged - (currencyExchanged * detailDiscount.discount) / 100
      totalDiscounted = totalDiscounted.toFixed(2)
    }

    //paypal functions btn
    const onApprove = (data, actions) => {
      return actions.order.capture().then(async function (details) {
        // Your code here after capture the order
        const transaction_ID = details.purchase_units[0].payments.captures[0].id

        // transaction id para devoluciones
        const data = await formatReservationDetails(details.id, transaction_ID)

        await updateReservation(agencyId, experienceId, reservationID, data)

        const dataUpdate = {
          agencyId,
          experienceId,
          reservationID,
        }

        if (
          singleExperience.isPartialCharge &&
          singleExperience.partialPercentage === 0 &&
          hotDeal.key
        ) {
          const updateFile = {
            paymentStatus: statePayments.DEFERRED_PAYMENT,

            status: stateReservation.PAID_OUT,
          }

          await updateReservationStatus(dataUpdate, updateFile)
        } else {
          const updateFile = {
            paymentStatus: isPartialCharge
              ? statePayments.PARTIAL_PAYMENT
              : statePayments.PAYMENT_SUCCESS,
            status: isPartialCharge
              ? stateReservation.PENDING
              : stateReservation.PAID_OUT,
          }

          await updateReservationStatus(dataUpdate, updateFile)
        }



        const experienceData = await getExperienceById(experienceId)
        const agencyData = await getAgency(agencyId)
        const reservationData = await getReservation(
          dataUpdate.agencyId,
          dataUpdate.experienceId,
          dataUpdate.reservationID,
        )

        if (!giftCard) {
          if (experienceData.category === 'HOTEL') {
            await handleHotelService(
              agencyData,
              experienceData,
              reservationData,
            )
          } else {
            await handleServiceCreation(
              agencyData,
              experienceData,
              reservationData,
            )
          }
        }

        await sendConfimReservationEmailToAgency(
          agencyData,
          experienceData,
          reservationData,
        )

        if (!!agencyData.channelIsActive) {
          const rooms = {
            [experienceData.channelRoomId]: [1, experienceData.board],
          }

          const arrival_hour = convertAMPMto24Hs(reservationData.hour)
          const dFrom = convertDateFormat(reservationData.dayFrom)
          const dTo = convertDateFormat(reservationData.dayTo)

          const costumer = {
            lname: `${reservationData.name}`,
            email: `${reservationData.email}`,
            fname: `${reservationData.lastName}`,
            arrival_hour: arrival_hour,
          }
          const guests = {
            men: `${reservationData.persons}`,
            children: `${reservationData.childs}`,
          }

          const xmlString = createNewReservationXML(
            agencyData.wubookApiKey,
            agencyData.lcode,
            dFrom,
            dTo,
            rooms,
            costumer,
            reservationData.finalPrice,
            guests,
          )

          await axios
            .post(
              `${process.env.REACT_APP_CHANNEL_API}`,
              xmlString,
              {
                headers: {
                  'Content-Type': 'text/plain',
                },
                responseType: 'text',
              },
            )
            .then(async (response) => {
              const reservation = response.data
              const parsedXml = await parseXmlToJson(reservation)
              const simplifiedJSON = simplifyReservation(parsedXml)
              if (simplifiedJSON.string === "Rooms not available") {
                // mejor manejo de error de cara al turista
                // en este flujo el turista ya pago
                alert("Habitación no disponible, consultar con Operador")
              }
              await updateReservation(agencyId, experienceId, reservationID, {
                channelReservationId: simplifiedJSON.string,
              })
            })
            .catch((error) => {
              console.error('Error:', error)
            })
        }

        await assignResource(agency.key, singleExperience, reservationData)

        if (agencyData.channelIsActive) {
          await checkResourceUsage(agencyData, experienceData, reservationData)
        }


        if (giftCard) {
          await sendConfirmReservationEmailToClientGiftCard(
            agencyData,
            experienceData,
            reservationData,
          )
        } else {
          await sendConfirmReservationEmailToClient(
            agencyData,
            experienceData,
            reservationData,
          )
        }

        let actualLinkReservation = `${process.env.REACT_APP_BASE_URL}/reservation/detail/${agencyData.key}/${experienceData.key}/${reservationData.key}/turist`

        window.location.href = actualLinkReservation
      })
    }

    const createOrder = (data, actions) => {
      return actions.order
        .create({
          purchase_units: [
            {
              amount: {
                currency_code: currency,
                value: `${totalDiscounted}`,
              },
            },
          ],
        })
        .then(async (orderId) => {
          if (
            singleExperience.isPartialCharge &&
            singleExperience.partialPercentage === 0 &&
            hotDeal.key
          ) {
            reservationID = hotDeal.key
            console.log(reservationID, 'entre', hotDeal.key)
            link += `${reservationID}/turist`

            return orderId
          } else {
            let reservationIDS = await handleReservation(orderId)
            console.log(reservationIDS, hotDeal)

            reservationDetail = reservationIDS[1]

            reservationID = reservationIDS[0]

            link += `${reservationID}/turist`

            return orderId
          }
        })
    }

    return (
      <div style={{ width: '100%' }}>
        <PayPalButtons
          disabled={
            isError || isExpirationCode || isErrorDay || !validateTerms()
          }
          // style={{ height: '10px' }}
          style={style}
          forceReRender={[currencyExchanged, currency, style]}
          fundingSource={undefined}
          createOrder={createOrder}
          onApprove={onApprove}
          onError={(err) => console.log(err)}
        />
      </div>
    )
  }

  /// EN VERIFYDETAILS ///

  const handleReservation = async (orderId = '') => {
    /// funcion para paypal
    if (orderId !== '') {
      const reservationDetails = formatReservationDetails(orderId) //se repite en handle reservation payment
      const reservationIDS = await createReservation(
        agency.key,
        singleExperience.key,
        reservationDetails,
      )

      return [reservationIDS, reservationDetails]
    }
    ////funcion para flow
    else {
      const reservationDetails = formatReservationDetails(orderId)
      const reservationIDS = await createReservation(
        agency.key,
        singleExperience.key,
        reservationDetails,
      )
      return reservationIDS
    }
  }

  const formatReservationDetails = (orderId = '', transaction_ID = '') => {
    if (singleExperience.category === 'HOTEL') {
      return {
        addons: selectedAddons,
        childs: childAmount,
        createdAt: getDateTime(),
        datePayment: getDateTime(),
        day: formatDateToDB(startDate),
        dayFrom: formatDateToDB(startDate),
        dayTo: formatDateToDB(endDate),
        email: email,
        experience: singleExperience.key,
        finalPrice: totalPrice + addonsPersonsPrice,
        hour: hotelHour,
        lastName: lastName,
        name: name,
        paymentStatus: statePayments.DEAL,
        persons: guestAmount,
        phone: phone,
        status: stateReservation.PENDING,
        timeZone: 'America/Santiago',
        partialPrice: singleExperience.partialPercentage
          ? singleExperience.partialPercentage + addonsPersonsPrice
          : 0,
        isPartialCharge: singleExperience.isPartialCharge
          ? singleExperience.isPartialCharge
          : false,
        payPalOrderId: orderId,
        transaction_ID: transaction_ID,
        flowOrder: '',
        clpToUsd: clpToUsd,
        discount:
          ((totalPrice + addonsPersonsPrice) * detailDiscount.discount) / 100,
        discountCode: detailDiscount.code ? detailDiscount.code : '',
        giftCard: giftCard
          ? {
            isGiftCard: giftCard,
            isReScheduled: false,
            giftedName: giftedName,
            giftedLastName: giftedLastName,
            giftedPhone: giftedPhone,
            giftedEmail: giftedEmail,
          }
          : { isGiftCard: giftCard },
      }
    } else {
      return {
        addons: selectedAddons,
        childs: childAmount,
        createdAt: getDateTime(),
        datePayment: getDateTime(),
        day:
          singleExperience.isPartialCharge &&
            singleExperience.partialPercentage === 0 &&
            hotDeal
            ? formatDateToDB(formatDateDif)
            : formatDateToDB(singleDate),
        email: email,
        experience: singleExperience.key,
        finalPrice: totalPrice + addonsPersonsPrice,
        hour: time,
        lastName: lastName,
        name: name,
        paymentStatus: statePayments.DEAL,
        persons: guestAmount,
        phone: phone,
        status: stateReservation.PENDING,
        timeZone: 'America/Santiago',
        partialPrice: singleExperience.partialPercentage
          ? singleExperience.partialPercentage + addonsPersonsPrice
          : 0,
        isPartialCharge: singleExperience.isPartialCharge
          ? singleExperience.isPartialCharge
          : false,
        payPalOrderId: orderId,
        transaction_ID: transaction_ID,
        flowOrder: '',
        clpToUsd: clpToUsd,
        discount:
          ((totalPrice + addonsPersonsPrice) * detailDiscount.discount) / 100,
        discountCode: detailDiscount.code ? detailDiscount.code : '',
        giftCard: giftCard
          ? {
            isGiftCard: giftCard,
            isReScheduled: false,
            giftedName: giftedName,
            giftedLastName: giftedLastName,
            giftedPhone: giftedPhone,
            giftedEmail: giftedEmail,
          }
          : { isGiftCard: giftCard },
      }
    }
  }

  /// EN COUD FUNCTION ///

  // para experiencia //
  const handleServiceCreation = async (
    agencyData,
    experienceData,
    reservationData,
  ) => {
    const { key: agencyId } = agencyData
    const {
      key: experienceId,
      category,
      type,
      minConfirmation,
    } = experienceData
    const {
      key: reservationId,
      hour,
      dayFrom,
      day,
      childs,
      persons,
    } = reservationData
    try {
      const scheduleResponse = await getExperienceSchedule(
        agencyId,
        experienceId,
        reservationId,
      )

      const { days } = scheduleResponse

      const selectedDay = (new Date(day).getDay() + 1) % 7

      const checkServices = await getServiceByDayAndHouse(
        agencyId,
        experienceId,
        day,
        hour,
      )

      if (checkServices.key) {
        //El servicio existe, se actualiza
        const newSales =
          type === 'GROUP'
            ? checkServices.sales + 1
            : checkServices.sales + childs + persons
        await updateService(agencyId, experienceId, checkServices.key, {
          sales: newSales,
        })
      } else {
        //el servicio no existe, se crea
        const newSales = type === 'GROUP' ? 1 : persons + childs

        const weeklyCapacity = days.find((item) => item.day === selectedDay)

        const serviceData = {
          sales: newSales,
          weeklyCapacity: weeklyCapacity.disponibility,
          hour,
          day: day,
          isConfirmed: false,
          responseConfirmed: false,
          experienceId: experienceId,
          createdAt: getDateTime(),
          minConfirmation: minConfirmation ? minConfirmation : 0,
        }

        await createService(agencyId, experienceId, serviceData)
      }
    } catch (err) {
      console.log({ message: 'Hubo un error al realizar el pago.', error: err })
    }
  }

  const getReservation = async (agencyId, experienceId, reservationId) => {
    const reservationResponse = await firebaseDb
      .doc(
        `/agency/${agencyId}/experiences/${experienceId}/reservation/${reservationId}`,
      )
      .get()

    return reservationResponse.data()
  }

  const getAgency = async (agencyId) => {
    const agencyResponse = await firebaseDb.doc(`/agency/${agencyId}`).get()

    return agencyResponse.data()
  }

  const getExperienceSchedule = async (agencyId, experienceId) => {
    try {
      const scheduleResponse = await firebaseDb
        .collection(`agency/${agencyId}/experiences/${experienceId}/schedule`)
        .get()

      let data = {}
      scheduleResponse.forEach((doc) => (data = { ...doc.data() }))
      return data
    } catch (err) {
      return { error: err }
    }
  } // para experiencias y hoteles la misma funcion

  const getServiceByDayAndHouse = async (agencyId, experienceId, day, hour) => {
    try {
      const serviceResponse = await firebaseDb
        .collection(`agency/${agencyId}/experiences/${experienceId}/services`)
        .where('day', '==', day)
        .where('hour', '==', hour)
        .get()

      let data = {}

      serviceResponse.forEach((doc) => (data = { ...doc.data() }))

      return data
    } catch (err) {
      return { completed: false, error: err }
    }
  }

  const updateService = async (
    agencyId,
    experienceId,
    serviceId,
    serviceData,
  ) => {
    try {
      await firebaseDb
        .doc(
          `agency/${agencyId}/experiences/${experienceId}/services/${serviceId}`,
        )
        .update(serviceData)
      return { completed: true, error: '' }
    } catch (err) {
      return { completed: false, error: err }
    }
  } // para experiencias y hoteles la misma funcion

  const getDateTime = () => {
    const date = new Date()
    const month = ('0' + (date.getMonth() + 1)).slice(-2)
    const day = ('0' + date.getDate()).slice(-2)
    const year = date.getFullYear()
    const hour = ('0' + date.getHours()).slice(-2)
    const minute = ('0' + date.getMinutes()).slice(-2)
    return `${year}-${month}-${day} ${hour}:${minute}`
  } // para experiencias y hoteles la misma funcion

  const createService = async (agencyId, experienceId, serviceData) => {
    try {
      const serviceResponse = await firebaseDb
        .collection(`agency/${agencyId}/experiences/${experienceId}/services`)
        .add(serviceData)

      //agregar key al servicio
      await firebaseDb
        .doc(
          `agency/${agencyId}/experiences/${experienceId}/services/${serviceResponse.id}`,
        )
        .update({ key: serviceResponse.id })

      return { completed: true, error: '', key: serviceResponse.id }
    } catch (err) {
      return { completed: false, error: err }
    }
  } // para experiencias y hoteles la misma funcion

  const updateReservation = async (
    agencyId,
    experienceId,
    reservationId,
    data,
  ) => {
    try {
      await firebaseDb
        .doc(
          `/agency/${agencyId}/experiences/${experienceId}/reservation/${reservationId}`,
        )
        .update(data)
      return { completed: true, error: '' }
    } catch (err) {
      return { completed: false, error: err }
    }
  } // para experiencias y hoteles la misma funcion

  // para experiencia //

  // ------------------------------------------------------------------------------------ //

  // para hotel //

  const handleHotelService = async (
    agencyData,
    experienceData,
    reservationData,
  ) => {
    try {
      const { key: agencyId } = agencyData
      const { key: experienceId } = experienceData
      const {
        dayFrom: startDate,
        dayTo: endDate,
        childs,
        persons,
        key: reservationId,
        hour,
      } = reservationData

      const datesArray = rangeBetweenDates(
        new Date(startDate.split('-')),
        new Date(endDate.split('-')),
      )
      datesArray.pop()

      const servicesResponse = await getExperienceServicesByType(
        agencyId,
        experienceId,
        'HOTEL',
      )

      const scheduleResponse = await getExperienceSchedule(
        agencyId,
        experienceId,
        reservationId,
      )

      const matchingServices = servicesResponse.filter(
        (service) =>
          service.startDate === startDate && service.endDate === endDate,
      )

      const rangeInServices = servicesResponse.map((service) => {
        // Filtrar los días de disponibilidad que coinciden con datesArray
        const availabilityMatches = service.disponibility.filter((disp) => {
          return datesArray.some((date) => date === disp.day)
        })

        // Si hay al menos un día de disponibilidad compartido, devolver el servicio
        if (availabilityMatches.length > 0) {
          return service
        }
      })

      // Filtrar y eliminar los elementos indefinidos del resultado
      const validServices = rangeInServices.filter(
        (service) => service !== undefined,
      )
      // Filtrar y eliminar los elementos indefinidos del resultado

      //Cuando tengo servicios que comparten fechas entro acá
      if (validServices.length > 0) {
        //Recorro los serv. obtenidos y a su vez verifico dentro "disponibility" el objeto a actualizar (disp.day === date)
        const updatedSales = []
        for (const service of validServices) {
          const updateDisponibility = service.disponibility.map((disp) => {
            const updatedDisp = datesArray.find((date) => disp.day === date)
            if (updatedDisp) {
              const newSales =
                experienceData.type === 'GROUP'
                  ? parseInt(disp.sales + 1)
                  : parseInt(disp.sales + persons + childs)
              updatedSales.push({ day: disp.day, newSales })
              return { ...disp, sales: newSales }
            }
            return disp
          })

          await updateService(agencyId, experienceId, service.key, {
            disponibility: updateDisponibility,
            sales:
              experienceData.type === 'GROUP'
                ? service.sales + 1
                : service.sales + childs + persons,
          })
        }
        //Una vez q actualizo el servicio, creo el nuevo servicio para la reserva entrante por lo cual se obtuvieron servicios compartidos
        if (matchingServices.length === 0) {
          const newDisponibility = datesArray.map((item) => {
            const selectedDay = new Date(item.split('-')).getDay()
            const { days } = scheduleResponse

            const weeklyCapacity = days.find((item) => item.day === selectedDay)
            const updatedSale = updatedSales.find((sale) => sale.day === item)

            const newSales = updatedSale
              ? updatedSale.newSales
              : experienceData.type === 'GROUP'
                ? parseInt(1)
                : parseInt(persons + childs)

            return {
              day: item,
              weeklyCapacity: weeklyCapacity.disponibility,
              sales: newSales,
            }
          })

          const createData = {
            startDate: startDate,
            endDate: endDate,
            type: 'HOTEL',
            disponibility: newDisponibility,
            hour: hour,
            minConfirmation: experienceData.minConfirmation
              ? experienceData.minConfirmation
              : 0,
            isConfirmed: false,
            responseConfirmed: false,
            createdAt: getDateTime(),
            experienceId,
            sales:
              experienceData.type === 'GROUP'
                ? parseInt(1)
                : parseInt(persons + childs),
          }

          await createService(agencyId, experienceId, createData)

          return {
            updated: true,
            message: 'El servicio fue creado exitosamente.',
          }
        } else {
          return {
            justUpdated: true,
            message: 'El servicio fue creado exitosamente.',
          }
        }
      } else if (matchingServices.length) {
        // Actualizar servicio existente solo cuando las fechas son coincidencia estricta (start && endDate)
        matchingServices.forEach(async (service) => {
          const updateDisponibility = service.disponibility.map((disp) => {
            const newSales =
              experienceData.type === 'GROUP'
                ? parseInt(disp.sales + 1)
                : parseInt(disp.sales + persons + childs)
            return { ...disp, sales: newSales }
          })

          await updateService(agencyId, experienceId, service.key, {
            disponibility: updateDisponibility,
            sales:
              experienceData.type === 'GROUP'
                ? service.sales + 1
                : service.sales + childs + persons,
          })
        })
      } else {
        // Si no ocurre nada de lo anterior, creo un servicio totalmente nuevo
        const newDisponibility = datesArray.map((item) => {
          const selectedDay = new Date(item.split('-')).getDay()
          const { days } = scheduleResponse

          const weeklyCapacity = days.find((item) => item.day === selectedDay)

          const newSales =
            experienceData.type === 'GROUP'
              ? parseInt(1)
              : parseInt(persons + childs)

          return {
            day: item,
            weeklyCapacity: weeklyCapacity.disponibility,
            sales: newSales,
          }
        })

        const createData = {
          startDate: startDate,
          endDate: endDate,
          type: 'HOTEL',
          disponibility: newDisponibility,
          hour: hour,
          minConfirmation: experienceData.minConfirmation
            ? experienceData.minConfirmation
            : 0,
          isConfirmed: false,
          responseConfirmed: false,
          createdAt: getDateTime(),
          experienceId,
          sales:
            experienceData.type === 'GROUP'
              ? parseInt(1)
              : parseInt(persons + childs),
        }

        await createService(agencyId, experienceId, createData)

        return {
          updated: true,
          message: 'El servicio fue creado exitosamente.',
        }
      }
    } catch (err) {
      console.log({
        message: 'Hubo un error al realizar el pago.',
        error: err,
      })
    }
  }

  const rangeBetweenDates = (startDate, stopDate) => {
    var dateArray = []
    var currentDate = startDate

    while (currentDate <= stopDate) {
      dateArray.push(formatDateToDB(new Date(currentDate)))
      var dat = new Date(currentDate.valueOf())
      dat.setDate(dat.getDate() + 1)
      currentDate = dat
    }
    return dateArray
  }

  async function getExperienceServicesByType(agencyId, experienceId, type) {
    try {
      const serviceResponse = await firebaseDb
        .collection(`agency/${agencyId}/experiences/${experienceId}/services`)
        .where('type', '==', type)
        .get()

      let data = []
      serviceResponse.forEach((doc) => {
        data.push(doc.data())
      })
      return data
    } catch (err) {
      console.log(err)
    }
  }

  const checkDateIsBetweenRange = (current, startDate, endDate) => {
    const dateToCheck = new Date(current.split('-'))
    dateToCheck.setHours(0, 0, 0, 0)
    const dateFrom = new Date(startDate.split('-'))
    const dateTo = new Date(endDate.split('-'))

    return dateToCheck >= dateFrom && dateToCheck < dateTo
  }

  // para hotel //

  ////////// CLOUD FUNCTION //////////

  ///////// MAILING /////////

  const sendConfirmReservationEmailToClient = async (
    agencyData,
    experienceData,
    reservationData,
  ) => {
    const data = {
      nameClient: `${reservationData.name} ${reservationData.lastName}`,
      logoAgency: agencyData.logo,
      nameExperience: experienceData.name,
      day:
        experienceData.category === 'HOTEL'
          ? reservationData.dayFrom
          : reservationData.day,
      hour:
        experienceData.category === 'HOTEL' ? '15:00PM' : reservationData.hour,
      descriptionExperience: experienceData.description,
      linkReservation: `${process.env.REACT_APP_BASE_URL}/reservation/detail/${agencyData.key}/${experienceData.key}/${reservationData.key}/turist`,
      phoneAgency: agencyData.phone.replace('+', '').replace(' ', ''),
      nameAgency: agencyData.name,
      emailClient: reservationData.email,
      emailAgency: agencyData.email,
      equipmentRequired: experienceData.equipmentRequired
        ? experienceData.equipmentRequired.map((er) => `-${er}`)
        : 'No necesita equipo requerido',
      termsAndConditionsUrl: `${process.env.REACT_APP_BASE_URL}/terms-and-conditions/${agencyData.key}`,
      paymentMethod: reservationData.payPalOrderId === '' ? 'Flow' : 'PayPal',
      discountCode: reservationData.discountCode,
    }
    await emailInstance.post('/client/reservation/confirm', data)
  }

  const sendConfirmReservationEmailToClientGiftCard = async (
    agencyData,
    experienceData,
    reservationData,
  ) => {
    const data = {
      nameClient: `${reservationData.name} ${reservationData.lastName}`,
      logoAgency: agencyData.logo,
      nameExperience: experienceData.name,
      day:
        experienceData.category === 'HOTEL'
          ? reservationData.dayFrom
          : reservationData.day,
      hour:
        experienceData.category === 'HOTEL' ? '15:00PM' : reservationData.hour,
      descriptionExperience: experienceData.description,
      linkReservation: `${process.env.REACT_APP_BASE_URL}/reservation/detail/${agencyData.key}/${experienceData.key}/${reservationData.key}/turist`,
      phoneAgency: agencyData.phone.replace('+', '').replace(' ', ''),
      nameAgency: agencyData.name,
      emailClient: reservationData.email,
      emailAgency: agencyData.email,
      equipmentRequired: experienceData.equipmentRequired
        ? experienceData.equipmentRequired.map((er) => `-${er}`)
        : 'No necesita equipo requerido',
      termsAndConditionsUrl: `${process.env.REACT_APP_BASE_URL}/terms-and-conditions/${agencyData.key}`,
      paymentMethod: reservationData.payPalOrderId === '' ? 'Flow' : 'PayPal',
      discountCode: reservationData.discountCode,
      giftedName: reservationData.giftCard.giftedName,
      giftedLastName: reservationData.giftCard.giftedLastName,
      giftedPhone: reservationData.giftCard.giftedPhone,
      giftedEmail: reservationData.giftCard.giftedEmail,
    }
    await emailInstance.post('/client/reservation/confirm/giftCard', data)
  }

  const sendConfirmReservationEmailToGiftedClient = async (
    agencyData,
    experienceData,
    reservationData,
  ) => {
    const data = {
      nameClient: `${reservationData.name} ${reservationData.lastName}`,
      logoAgency: agencyData.logo,
      nameExperience: experienceData.name,
      day:
        experienceData.category === 'HOTEL'
          ? reservationData.dayFrom
          : reservationData.day,
      hour:
        experienceData.category === 'HOTEL' ? '15:00PM' : reservationData.hour,
      descriptionExperience: experienceData.description,
      linkReservation: `${process.env.REACT_APP_BASE_URL}/reservation/detail/${agencyData.key}/${experienceData.key}/${reservationData.key}/turist`,
      phoneAgency: agencyData.phone.replace('+', '').replace(' ', ''),
      nameAgency: agencyData.name,
      emailClient: reservationData.email,
      emailAgency: agencyData.email,
      equipmentRequired: experienceData.equipmentRequired
        ? experienceData.equipmentRequired.map((er) => `-${er}`)
        : 'No necesita equipo requerido',
      termsAndConditionsUrl: `${process.env.REACT_APP_BASE_URL}/terms-and-conditions/${agencyData.key}`,
      paymentMethod: reservationData.payPalOrderId === '' ? 'Flow' : 'PayPal',
      discountCode: reservationData.discountCode,
      giftedName: reservationData.giftCard.giftedName,
      giftedLastName: reservationData.giftCard.giftedLastName,
      giftedPhone: reservationData.giftCard.giftedPhone,
      giftedEmail: reservationData.giftCard.giftedEmail,
    }
    await emailInstance.post('/client/reservation/confirm/gifted', data)
  }

  const sendConfimReservationEmailToAgency = async (
    agencyData,
    experienceData,
    reservationData,
  ) => {
    const checkServices = await getServiceByDayAndHouse(
      agencyData.id,
      experienceData.id,
      reservationData.day,
      reservationData.hour,
    )
    const data = {
      nameClient: `${reservationData.name} ${reservationData.lastName}`,
      nameExperience: experienceData.name,
      persons: reservationData.persons,
      childs: reservationData.childs,
      day:
        experienceData.category === 'HOTEL'
          ? reservationData.dayFrom
          : reservationData.day,
      hour:
        experienceData.category === 'HOTEL' ? '3:00PM' : reservationData.hour,
      nameAgency: agencyData.name,
      emailAgency: agencyData.email,
      amount: reservationData.finalPrice,
      partialAmount: reservationData.isPartialCharge
        ? (reservationData.finalPrice * reservationData.partialPrice) / 100
        : 0,
      dashboardUrl: `${process.env.REACT_APP_DASHBOARD}/#/experiences/reservation/${agencyData.key}/${experienceData.key}/${reservationData.key}/${checkServices.key}`,
      termsAndConditionsUrl: `${process.env.REACT_APP_BASE_URL}/terms-and-conditions/${agencyData.key}`,
      discountCode: reservationData.discountCode,
    }

    await emailInstance.post('/agency/reservation/confirm', data)
  }

  ///////// MAILING /////////
  return (
    <>
      <PayPalButton />
    </>
  )
}

export default PayPalModule
